import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from "@mui/material";

const AdminTrainingReset = ({
  isAdmin,
  open,
  resetAllTraining,
  setSnackbarMessage,
  setSnackbarOpen
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLevel, setSelectedLevel] = useState("");

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleConfirm = async () => {
    if (!selectedLevel) {
      setSnackbarMessage("Please select a level to reset");
      setSnackbarOpen(true);
      return;
    }

    try {
      await resetAllTraining({ userId: open?.userId, levelName: selectedLevel });
      setSnackbarMessage(
        `Training progress for ${selectedLevel} reset successfully`
      );
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error resetting training progress:", error);
      setSnackbarMessage("Failed to reset training progress");
      setSnackbarOpen(true);
    } finally {
      handleCloseModal();
    }
  };

  return (
    <>
      {isAdmin && (
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#5daeff",
            fontSize: "12px",
            textTransform: "none",
            color: "#FCFCFC",
            mt: 1,
            "&:hover": { backgroundColor: "#4b96e1" }
          }}
          onClick={handleOpenModal}
        >
          Reset Progress
        </Button>
      )}

      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
            boxShadow: "0 12px 40px rgba(0,0,0,0.25)"
          }
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: "#333"
          }}
        >
          Reset Training Progress
        </DialogTitle>

        <DialogContent>
          <Typography
            variant="body2"
            sx={{ mb: 2, color: "#555", textAlign: "center" }}
          >
            This action will permanently remove all training progress for the
            selected level and also delete any points earned for it.
          </Typography>

          <Box display="flex" justifyContent="center">
            <RadioGroup
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
            >
              <FormControlLabel
                value="level1"
                control={<Radio />}
                label="Level 1"
              />
              <FormControlLabel
                value="level2"
                control={<Radio />}
                label="Level 2"
              />
              <FormControlLabel
                value="level3"
                control={<Radio />}
                label="Level 3"
              />
            </RadioGroup>
          </Box>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="outlined"
            size="small"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              px: 3
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#5daeff",
              textTransform: "none",
              borderRadius: 2,
              px: 3,
              color: "#fff",
              "&:hover": { backgroundColor: "#4b96e1" }
            }}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AdminTrainingReset;
